<template>
  <div
    class="seniorDetailBox"
    :class="{ inApp: $root.$data.isApp }"
  >
    <common-title
      v-if="this.$root.whatEev!='miniprogram'"
      titleName="个人信息"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    />
    <van-loading
      v-if="loadingTip"
      size="20px"
    >加载中...</van-loading>
    <template v-else>
      <div v-if="seniorDetail">
        <SeniorCard :seniorDetail="seniorDetail" />
        <div class="centerBox">
          <ul class="tabBox">
            <li
              v-for="(item,index) in tabList"
              :key="index"
              @click="tabClick(index)"
              :class='{"active":tabIndx===index}'
            >{{item}}</li>
          </ul>

          <AboutMe
            v-show="tabIndx===0"
            :seniorDetail="seniorDetail"
          />
          <Tutor v-show="tabIndx===1" />

        </div>
      </div>
      <EmptyData
        :emptyName="'noEvaluation'"
        v-else
      />
    </template>

  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { reqSeniorDetail } from '@/api/majorSenior';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import SeniorCard from './components/seniorCard.vue';
import AboutMe from './components/aboutMe.vue';
import Tutor from './components/tutor.vue';

export default {
  components: {
    CommonTitle,
    SeniorCard,
    AboutMe,
    Tutor,
    EmptyData,
  },
  props: {},
  data() {
    return {
      defaultHead: require('@/assets/img/majorSenior/headIcon.png'),
      tabList: ['关于我', '1v1辅导'],
      tabIndx: 0,
      seniorDetail: {},
      loadingTip: true,

    };
  },

  computed: {},
  created() {
    this.getSeniorDetail();
  },

  mounted() {
  },

  methods: {
    tabClick(index) {
      this.tabIndx = index;
    },
    // 个人信息
    async getSeniorDetail() {
      const { seniorId } = this.$route.query;
      const res = await reqSeniorDetail(seniorId);
      if (res?.code === 0) {
        this.seniorDetail = res?.data;
        this.loadingTip = false;
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.seniorDetailBox {
  width: 100%;
  padding-top: 100px;
  .centerBox {
    box-sizing: border-box;
    padding: 36px 36px 206px 36px;
    .tabBox {
      display: flex;
      padding-bottom: 20px;
      li {
        margin-right: 45px;
        color: #333;
        font-weight: 500;
        font-size: 33px;
        line-height: 45px;
      }
      .active {
        position: relative;
        color: #ff7f41;
        &::before {
          position: absolute;
          top: 52px;
          left: 50%;
          width: 40px;
          height: 5px;
          background: #ff7f41;
          border-radius: 5px;
          transform: translate(-50%, 0);
          content: '';
        }
      }
    }
  }
  ::v-deep .van-loading {
    top: 26px;
    text-align: center;
  }
}
.inApp {
  padding-top: 0;
}
</style>
